// disable patch requestAnimationFrame
(window as any).__Zone_disable_requestAnimationFrame = true;
